import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

interface Screenshot {
  src: string;
  label: string;
  caption: string;
}

@Component({
  selector: 'app-screenshot-carousel-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './screenshot-carousel-dialog.html',
  styleUrl: './screenshot-carousel-dialog.css',
})
export class ScreenshotCarouselDialog {
  current = 0;

  // ─── SWAP THESE WITH REAL SCREENSHOTS WHEN READY ─────────────────────────
  screenshots: Screenshot[] = [
    {
      src: 'assets/spinner/studentDash.png',
      label: 'Student Dashboard',
      caption:
        'Everything a student needs in one place — deadlines, messages, and a snapshot of where they stand.',
    },
    {
      src: 'assets/spinner/studentProfile.png',
      label: 'Student Profile',
      caption:
        'More than a bio — a living record of interests, goals, and growth that follows students through every grade.',
    },
    {
      src: 'assets/spinner/studentNetwork.png',
      label: 'Student Network',
      caption:
        'Connect with peers, discover shared interests, and start building the relationships that matter beyond the classroom.',
    },
    {
      src: 'assets/spinner/studentCareers.png',
      label: 'Student Careers Hub',
      caption:
        'Explore careers, browse opportunities, and start mapping a path from where you are to where you want to be.',
    },
    {
      src: 'assets/spinner/counselorDash.png',
      label: 'Counselor Dashboard',
      caption: "A bird's-eye view of the whole caseload — so no student ever falls off the radar.",
    },
    {
      src: 'assets/spinner/counselorPosts.png',
      label: 'Counselor Posts',
      caption:
        "Send the right message to the right students — targeted announcements that actually reach who they're meant for.",
    },
    {
      src: 'assets/spinner/counselorStudents.png',
      label: 'Counselor Student Roster',
      caption: 'Every student, at a glance. Filter, search, and get to the right kid in seconds.',
    },
    {
      src: 'assets/spinner/counselorMessages.png',
      label: 'Counselor Messages',
      caption:
        'Direct, private conversations with students — no email threads, no missed notes, no falling through the cracks.',
    },
    {
      src: 'assets/spinner/counselorCareer.png',
      label: 'Counselor Careers',
      caption:
        'Build and manage career resources for students — curated opportunities posted directly to the kids who need them.',
    },
  ];
  // ─────────────────────────────────────────────────────────────────────────

  constructor(private dialogRef: MatDialogRef<ScreenshotCarouselDialog>) {}

  /**
   * Navigates to the previous screenshot, wrapping around to the last.
   */
  prev(): void {
    this.current = this.current === 0 ? this.screenshots.length - 1 : this.current - 1;
  }

  /**
   * Navigates to the next screenshot, wrapping around to the first.
   */
  next(): void {
    this.current = this.current === this.screenshots.length - 1 ? 0 : this.current + 1;
  }

  /**
   * Jumps directly to a screenshot by index.
   * @param {number} index
   */
  goTo(index: number): void {
    this.current = index;
  }

  close(): void {
    this.dialogRef.close();
  }
}
